import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-construction-materials-list',
  templateUrl: './construction-materials-list.component.html',
  styleUrl: './construction-materials-list.component.css'
})
export class ConstructionMaterialsListComponent {
 displayedColumns: string[] = ['srNo',
    'material', 'category',
    'code', 'quality', "action"
  ];


  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private apiService: ApiService, private toastrMsgService: ToastrMsgService) {

  }



  ngOnInit(): void {

    this.fetchData();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }
  activeMaterialCount(): number {
    return (this.dataSource.data as Record<string, unknown>[]).filter((m) => {
      const qty = Number(m?.['qty'] ?? m?.['quantity'] ?? 0);
      return qty > 0;
    }).length;
  }

  fetchData() {
    
    this.apiService.getconstructionmaterials().subscribe({
      next: (res: any) => {
        this.dataSource.data = Array.isArray(res) ? res : res?.data ?? [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage ?? err?.error?.error ?? 'Failed to load materials');
      },
    });
  }




}